var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImportTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/import/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.27857143,4.28571429 L7.14285714,4.28571429 L7.14285714,0.714285714 C7.14285714,0.321428571 6.82142857,0 6.42857143,0 L3.57142857,0 C3.17857143,0 2.85714286,0.321428571 2.85714286,0.714285714 L2.85714286,4.28571429 L1.72142857,4.28571429 C1.08571429,4.28571429 0.764285714,5.05714286 1.21428571,5.50714286 L4.49285714,8.78571429 C4.77142857,9.06428571 5.22142857,9.06428571 5.5,8.78571429 L8.77857143,5.50714286 C9.22857143,5.05714286 8.91428571,4.28571429 8.27857143,4.28571429 Z M0,11.4285714 C0,11.8214286 0.321428571,12.1428571 0.714285714,12.1428571 L9.28571429,12.1428571 C9.67857143,12.1428571 10,11.8214286 10,11.4285714 C10,11.0357143 9.67857143,10.7142857 9.28571429,10.7142857 L0.714285714,10.7142857 C0.321428571,10.7142857 0,11.0357143 0,11.4285714 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/import/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/export-polygon",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -3.000000)",
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportTool);
export default __webpack_public_path__ + "static/media/icon_import_tool.3c798621e07bde321b5570c6349b5481.svg";
export { ForwardRef as ReactComponent };